<template>
    <div>
         <!-- main-area -->
         <main class="fix">
                <!-- breadcrumb-area -->
                <section class="breadcrumb__area breadcrumb__bg">
                    <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100 kantor-bg"></div>
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="breadcrumb__content">
                                    <h2 class="title">Visi Misi</h2>
                                    <nav aria-label="breadcrumb">
                                        <ol class="breadcrumb">
                                            <li class="breadcrumb-item"><a href="javascript:void(0);">Profil</a></li>
                                            <li class="breadcrumb-item active" aria-current="page">Visi Misi</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="breadcrumb__shape">
                        <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                        <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                    </div>
                </section>

                <section class="about__area-five about__area-seven">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="about__content-five">
                                        
                                        
                                        <p v-html="uraian"></p>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="about__shape-wrap-four">
                            <img src="assets/img/images/h4_about_shape01.png" alt="">
                            <img src="assets/img/images/h4_about_shape02.png" alt="" data-parallax='{"x" : -80 , "y" : -80 }'>
                        </div>
                    </section>
                    <!-- about-area-end -->
                <!-- breadcrumb-area-end -->
               
                
            </main>
            <!-- main-area-end -->
    
    
    </div>
    </template>

    <script>



        export default {

            data() {
                return {
          
                    list_data: [],
                    page_first: 1,
                    page_last: 0,
                    cari_value: "",
                    uraian: "",
                    file_path: this.$store.state.URL_APP + "uploads/",
                }
            },
            methods: {
            getView: function() {
            fetch(this.$store.state.ADD_URL_PROFIL, {
                method: "GET",
                headers: {
                "content-type": "application/json",
                },
            })
                .then(res => res.json())
                .then(res_data => {
                this.cek_load_data = false;

                var tugas_pokok = res_data[0];
                this.uraian = tugas_pokok.uraian;
                });
            },

            // ================== PAGINASI ====================
            alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
            },

            btn_prev : function(){
                    this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getView();
            },

            btn_next : function(){
                
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getView();
            },

            cari_data : function(){

                this.page_first = 1;
                this.getView();
            },
            onFileSelected: function(event) {
            this.form.file = event.target.files[0];
            },
            convert_tgl: function(dateString) {
            var date = new Date(dateString);
            return date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear();
            }
            // ================== PAGINASI ====================
            },
            // =============================================================== METHODS =========================================================================

            mounted() {

            this.getView();


                
            }
            };



    </script>



